import { memo } from 'react'
import styles from '../navigationPanel.module.css'
import { NavButton } from '../navButton/navButton'
import type { INavItem } from '../../../constants/navigationItems'

interface NavListProps {
  items: INavItem[]
  onNavClick?: () => void
  ariaLabel?: string
}

export const NavList = memo(function NavList({ items, onNavClick, ariaLabel }: NavListProps) {
  return (
    <ul className={styles.navList} aria-label={ariaLabel}>
      {items.map(navItem => (
        <li key={navItem.link}>
          <NavButton navItem={navItem} onClick={onNavClick} />
        </li>
      ))}
    </ul>
  )
})
